import BaseRepository from './base-repository';
import { UserEntity } from '@/types/User';

export default class UsersRepository extends BaseRepository<UserEntity> {
    constructor() {
        super('/clfinder/users', 'id');
    }

    public users(email: string) {
        return this._get(this._resource, { email });
    }
}
